<template lang="pug">
  div
    v-data-table.elevation-1.mt-4(
      :headers="headers"
      :items="casesWithCompanies"
      :items-per-page="5"
      :sort-by="['ID']"
    )
      template(v-slot:item.Actions="{item, value}")
        v-btn(
          color="primary"
          @click="openCase(item)"
        ) Open
</template>

<script>
let headers = [
  { text: 'ID', value: 'ID', },
  { text: 'Company name', value: 'company_name' },
  { text: 'Category', value: 'case_profile_type' },
  { text: 'Status', value: 'status' },
  { text: 'Actions', value: 'Actions' }
]

export default {
  data: () => ({
    cases: []
  }),
  
  mounted() {
    this.getCases()
  },

  methods: {
    openCase({ ID }) {
      this.$router.push(`/lawyer/case/${ID}`)
    },

    getCases() {
      this.axios.get("/lawyer/cases")
        .then(r => {
          this.cases = r.data
        })
        .catch(console.error)
    }
  },

  computed: {
    companies() {
      return this.$store.state.companies
    },

    casesWithCompanies() {
      return this.cases.map(v => {
        if (
          this.companies
          && this.companies.filter(c => c.ID == v.company_id).length > 0
        ) {
          v.company_name = this.companies.filter(c => c.ID == v.company_id)[0].CompanyProfile.name
        }
        
        return v
      })
    },

    headers() {
      return headers
    }
  }
}
</script>